import React from 'react';
import { reduxForm, getFormValues } from 'redux-form';
import { useSelector, connect, useDispatch } from 'react-redux';
import { scrollToError } from '../../../../redux/actions/ui-trigger/ui-trigger-action';
import { NFCrossSellingFormContainer } from './styles';
import {
  CrossSellingFormType,
  renderFormFields,
  handleSubmit,
  CrossSellingFormProps
} from './utils';
import { IStore, AppDispatch } from '../../../../store.type';
import CommonButton from '../../../../components/common-button/CommonButton';
import { HUNDRED_THOUSAND } from '../../../../utils/constants';
import { changeNiumForexScreen } from '../../../../redux/actions/nium-forex/nium-forex-action';

import { NF_SCREENS } from '../../root/screenConstants';
import { niumForexCrossSellingSelector } from '../../../../redux/selectors';
import { BACK_ARROW_SVG_ICON } from '@Images';

const NFCrossSelling = (props: CrossSellingFormProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const formValues = useSelector((state: IStore) => getFormValues('crossSellingForm')(state));
  const crossSellingState = useSelector(niumForexCrossSellingSelector);
  const {
    labels,
    explore: { screens },
    selectedProducts,
    currentExploreTab
  } = crossSellingState;

  const handleFormSubmit = (values: CrossSellingFormType) => {
    handleSubmit(values, dispatch, selectedProducts);
  };

  return (
    <NFCrossSellingFormContainer>
      <div className="form-ui-container">
        <img
          className="back-button"
          alt="back"
          src={BACK_ARROW_SVG_ICON}
          width={16}
          height={16}
          onClick={() => dispatch(changeNiumForexScreen(NF_SCREENS.cross_selling))}
        />
        <div className="nf-cross-sell-view">
          <form className="form-container" onSubmit={props.handleSubmit(handleFormSubmit)}>
            <div className="header-container">
              <span className="__title">{screens[currentExploreTab].title}</span>
              <span className="__description">{labels.forexCardFormDescription}</span>
            </div>
            {renderFormFields(formValues, props, crossSellingState)}
            <CommonButton width={418} height={50} text="Proceed" type="primary" />
          </form>
        </div>
      </div>
    </NFCrossSellingFormContainer>
  );
};

const createReduxForm = reduxForm({
  form: 'crossSellingForm',
  onSubmitFail: scrollToError
});

function mapStateToProps(state: IStore) {
  const {
    rootReducer: {
      userStatusReducer: { email, remitter_individual_mobile_number: phone }
    }
  } = state;
  return {
    initialValues: {
      email,
      contact_number: phone,
      forex_currency: 'USD',
      is_forex_applied: false,
      forex_amount: HUNDRED_THOUSAND
    }
  };
}

const NFCrossSellingForm = createReduxForm(NFCrossSelling);

export default connect(mapStateToProps)(NFCrossSellingForm);
